import React from 'react';
import { Button } from '@dexma/ui-components';

import i18n from 'asset/translation';
import { StyledModelFooter } from 'adapter/in/common/components/ConfirmButtonGroup/style';

export type ButtonVariant = 'primary' | 'destructive' | 'outline' | 'secondary';

export type ConfirmButtonGroupsDataIdContext = {
    optional?: string;
    main: string;
    cancel: string;
};
interface ConfirmButtonGroupProps {
    isLoading: boolean;
    showIcon?: boolean;
    mainButtonText?: string;
    cancelButtonText?: string;
    optionalButtonText?: string;
    onOptionalClick?: () => void;
    onMainClick?: () => void;
    onCancel: () => void;
    optionalButtonVariant?: ButtonVariant;
    mainButtonVariant?: ButtonVariant;
    proceedType?: 'submit' | 'button';
    iconBefore?: string;
    dataIdContext: ConfirmButtonGroupsDataIdContext;
}

export const ConfirmButtonGroup: React.FC<ConfirmButtonGroupProps> = ({
    isLoading,
    showIcon,
    mainButtonText,
    cancelButtonText,
    optionalButtonText,
    onOptionalClick,
    onMainClick,
    onCancel,
    optionalButtonVariant = 'primary',
    mainButtonVariant = 'destructive',
    proceedType = 'submit',
    iconBefore,
    dataIdContext,
}) => (
    <StyledModelFooter data-testid='modal-footer'>
        {onOptionalClick && optionalButtonText && (
            <Button
                variant={optionalButtonVariant}
                text={optionalButtonText}
                isLoading={isLoading}
                onClick={!isLoading ? onOptionalClick : undefined}
                data-testid='optional'
                dataId={dataIdContext.optional}
                iconBefore={showIcon && iconBefore ? iconBefore : undefined}
                disabled={isLoading}
                type='button'
            />
        )}

        <Button
            variant={mainButtonVariant}
            type={proceedType}
            text={mainButtonText ?? i18n.t('dashboards.create.saveButton')}
            data-testid={isLoading ? 'loading' : 'main'}
            isLoading={isLoading}
            iconBefore={showIcon && iconBefore ? iconBefore : undefined}
            onClick={!isLoading ? onMainClick : undefined}
            dataId={dataIdContext.main}
            disabled={isLoading}
        />

        <Button
            variant='outline'
            type='button'
            text={cancelButtonText ?? i18n.t('common.cancel')}
            data-testid='cancel'
            onClick={onCancel}
            dataId={dataIdContext.cancel}
        />
    </StyledModelFooter>
);
